document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("global-modal-designers");
  const modalContent = modal ? modal.querySelector('.modal-content-designers') : null;
  

  if (modal && modalContent) {
    // Add class for modal styling
    modal.classList.add("modal");

    // Handle open modal
    document.querySelectorAll('[data-modal-open="global-modal-designers"]').forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const designersContent = document.getElementById('designers-we-take');
        
        if (designersContent) {
          const contentClone = designersContent.cloneNode(true);
          modalContent.innerHTML = '';
          modalContent.appendChild(contentClone);
          
          modal.classList.add("is-active");
          document.body.classList.add("no-scroll");
        }
      });
    });

    // Handle close buttons
    modal.querySelectorAll("[data-modal-close]").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        modal.classList.remove("is-active");
        document.body.classList.remove("no-scroll");
      });
    });

    // Close when clicking outside
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        e.preventDefault();
        modal.classList.remove("is-active");
        document.body.classList.remove("no-scroll");
      }
    });
  }
});
